@if (status) {
  <div class="flex items-center pr-1 pl-0 app-status">
    <div class="icon-container">
      @switch (status.toString()) {
        @case (is.NEW) {
          <span class="material-icons-outlined">post_add</span>
        }
        @case (is.SUBMITTED) {
          <span class="text-blue-500 material-icons-outlined">check_circle</span>
        }
        @case (is.RESUBMITTED) {
          <span class="text-blue-500 material-icons-outlined">check_circle</span>
        }
        @case (is.RETURNED) {
          <span class="text-yellow-500 material-icons-outlined">assignment_return</span>
        }
        @case (is.INREVIEW) {
          <span class="material-icons-outlined">fact_check</span>
        }
        @case (is.APPROVED) {
          <span class="material-icons-outlined">insert_emoticon</span>
        }
        @case (is.CLOSED) {
          <span class="material-icons-outlined">cancel_presentation</span>
        }
        @case (is.CLOSEDOTHER) {
          <span class="material-icons-outlined">cancel_presentation</span>
        }
        @case (is.CLOSEDNONRESPONSE) {
          <span class="material-icons-outlined">cancel_presentation</span>
        }
        @case (is.ARCHIVED) {
          <span class="material-icons-outlined">inventory_2</span>
        }
      }
    </div>
    <div class="label-container">
      <div class="label">{{ statusLabel }}</div>
    </div>
    <div class="mr-2 content-container"><ng-content></ng-content></div>
  </div>
}
